<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import { BASE_URL } from "@/package/config/axios";

const route = useRoute();

onBeforeMount(() => {
  window.location.href = `${BASE_URL}api/v2/oauth/registration?promocode=${route.params.code || route.query.promocode || route.query.code}`;
});
</script>

<template>
  <main></main>
</template>
